<ng-container *ngIf="hasInputData()">
    <mat-form-field style="width: 100%;" class="edms-auto" [formGroup]="form">
        <mat-label>{{label}}</mat-label>
        <input #searchText type="text" placeholder="" matInput [formControlName]="controlName"
            [matAutocomplete]="auto">
        <!-- <button mat-button  mat-icon-button > -->
        <i class="fa fa-times" aria-label="Clear" (click)="clearSearchText()" matSuffix
            style="cursor:pointer; font-weight: bolder;"></i>
        <!-- </button> -->
        <mat-autocomplete #auto="matAutocomplete" class="edms-auto" (optionSelected)="selected($event)" (closed) = "closed($event)" (opened) = "opened($event)"
            [displayWith]="displayProperty.bind(this)" showPanel="true" (optionsScroll)="onScroll()">
            <mat-option title="{{option[textField]}}" *ngFor="let option of filteredOptions | async"
                [value]="option">
                {{option[textField]}}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="hasRequiredError()">
            {{error}}
        </mat-error>
        <mat-error *ngIf="hasFormControlError()">
            Please select the value only from the available list
        </mat-error>
    </mat-form-field>
</ng-container>